import { supabase } from '@supabaseClient';
import { fetchRatesWithRetry } from '@/integrations/api/currency';
import { convertTransactionAmounts, type ConversionResult } from './currencyConversion';

/**
 * Converts an amount and fee into the currency of the given cash account.
 *
 * Balance RPCs post to the account in its own currency and refuse a cross-currency request
 * without converted amounts. When the currencies match, no rates are fetched.
 */
export async function convertToAccountCurrency(
  userId: string,
  accountId: string,
  amount: number,
  fee: number,
  fromCurrency: string
): Promise<ConversionResult> {
  const { data: account, error } = await supabase
    .from('accounts')
    .select('currency')
    .eq('id', accountId)
    .eq('user_id', userId)
    .single();
  if (error || !account) throw new Error(`Account ${accountId} not found`);

  return convertTransactionAmounts(
    { amount, fee, fromCurrency, toCurrency: account.currency },
    fetchRatesWithRetry
  );
}
